import { NodeQuery } from '../../../../../Components/QueryComponents/NodeQuery/NodeQuery';
import { IColumnDef } from '../../../../../Types/ColumnDefType';
import { headerColumns } from '../../Utils/defaultColumns';
import {
  getStringValue,
  attributeDefToDataPath,
} from '../../../../../Utils/dataUtils';
import ObjektLankHeader from './ObjektLank/ObjektLankHeader';
import EDCaptionedValue from '../../../../../BaseComponents/CaptionedValue/EDCaptionedValue';

interface IProps {
  displayLabel: string;
  infoClick: () => void;
  collectionName: string;
  id: string | null;
}

const AssociationHeaderQuery = (props: IProps) => {
  const columndefs: IColumnDef[] = headerColumns(props.collectionName);
  const fieldDefs = columndefs.map(coldef => coldef.attributeDef);
  return (
    <NodeQuery
      id={props.id}
      collectionName={props.collectionName}
      fieldDefs={fieldDefs}
    >
      {(loading, node) => (
        <EDCaptionedValue label={props.displayLabel} name={props.displayLabel}>
          <ObjektLankHeader
            label={columndefs
              .map(columndef =>
                getStringValue(
                  node,
                  attributeDefToDataPath(columndef.attributeDef)
                )
              )
              .join(' ')}
            onClick={props.infoClick}
          />
        </EDCaptionedValue>
      )}
    </NodeQuery>
  );
};

export default AssociationHeaderQuery;
